import { Button } from "@/core/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/core/components/ui/dialog";
import type { IPayrollSheetApprovalStatus } from "@/payroll/payroll.d";
import { RequestApprovalDialogBody } from "./request-approval-dialog-body";
import type { ISheetApprovalRequestState } from "./types";
import { useApprovalRecipientSelection } from "./use-approval-recipient-selection";
import { getSendButtonLabel } from "./utils";

interface RequestApprovalDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (userIds: string[]) => void;
  isSending: boolean;
  state: ISheetApprovalRequestState;
  approvalStatus: IPayrollSheetApprovalStatus | null | undefined;
}

export const RequestApprovalDialog = ({
  open,
  onOpenChange,
  onConfirm,
  isSending,
  state,
  approvalStatus,
}: RequestApprovalDialogProps) => {
  const { selectedIds, toggle, toggleAll } = useApprovalRecipientSelection(
    open,
    state,
    approvalStatus,
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        description="Choose which approvers to email for this pay period"
        className="max-h-[85vh] max-w-xl grid-rows-[auto_minmax(0,1fr)_auto]"
      >
        <DialogHeader>
          <DialogTitle>Request approval?</DialogTitle>
        </DialogHeader>
        <RequestApprovalDialogBody
          state={state}
          approvalStatus={approvalStatus}
          selectedIds={selectedIds}
          onToggle={toggle}
          onToggleAll={toggleAll}
        />
        <DialogFooter>
          <Button
            variant="secondary"
            size="sm"
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            size="sm"
            onClick={() => onConfirm(selectedIds)}
            loading={isSending}
            disabled={selectedIds.length === 0}
          >
            {getSendButtonLabel(selectedIds.length)}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
